import React from 'react';

type HiddenInputProps = React.InputHTMLAttributes<HTMLInputElement>;

/**
 *  required is undefined here, because it's not valid HTML, but required is always sent by the backend
 * @param inputProps
 * @constructor
 */
export function HiddenInput(inputProps: HiddenInputProps) {
  return (
    <input {...inputProps} type="hidden" required={undefined} />
  );
}
